import React from 'react';
import { SanitizedOrder } from '../../../../types/order/Order';

interface OrderDetailContextInterface {
  order?: SanitizedOrder;
  reFetchOrder?: Function;
}

export interface OrderDetailContextAfterLoad {
  order: SanitizedOrder;
  reFetchOrder: Function;
}

const OrderContext = React.createContext<OrderDetailContextInterface>({
  order: undefined,
  reFetchOrder: undefined,
});

export default OrderContext;
